 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		1: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "static/chunks/" + ({"0":"framework","2":"e8d1ae27d4c06f7b68c16b26315717e91bddb7d0","5":"066b2e1a2af14eeb756577bd53d1f7049c976134","6":"c9c6fe98","8":"a95415a8aeb79124093d0390e143f2726276ebc5","10":"c82b4ea90151474f05155d9f47e423993161f57b","11":"655b2acc034e94f6298c0d7764c5b2dcc4c98172","12":"75fc9c18","13":"a741c1f8d8b7828094065c14d76e11114ea67124","14":"cb587b6468196656336b0d2e9a2a1e3226ab0577","19":"1b71e3b478f54a1cc4850717986c2c1e9f96663e","28":"e7d6f8c048c84f4c986d4c4351435fec8464a369","29":"250f2b824d3e0d1196f822fad573a2e7565d84ba","33":"57d38bdc9a19095e81d66598a6c6d25fe18b80ef","36":"fb8e0a985f1e2798051d4965d984ea2bb1775ce2","39":"c8f7fe3b0e41be846d5687592cf2018ff6e22687","40":"cae5737e08c1a9948a650822c6a84ae1b82f4d13","41":"d282c9243d032fb2d2ee2da709a47048b1d844db","122":"reactPlayerDailyMotion","123":"reactPlayerFacebook","124":"reactPlayerFilePlayer","125":"reactPlayerKaltura","126":"reactPlayerMixcloud","127":"reactPlayerPreview","128":"reactPlayerSoundCloud","129":"reactPlayerStreamable","130":"reactPlayerTwitch","131":"reactPlayerVidyard","132":"reactPlayerVimeo","133":"reactPlayerWistia","134":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"c79e8c1855af7b4c66de","2":"07b24b3a789e45727547","5":"00c29f145173807985e7","6":"53fad1c09bf21facce0c","8":"adde3152bbd39286eaed","10":"4677d80b9543c668c250","11":"d9dba2ff11a6921a18cb","12":"af6c63e5da409560ce9f","13":"92cd9e3b307ec26f6f76","14":"596aad08735fd0bf901e","19":"b799d090d38fb67ffabc","28":"acb80740a5a4c884bb00","29":"b118485ba3bf1d73c06a","33":"1661453cfe8b338f177e","36":"dbfa2ecb59a6647f90f0","39":"643c50fb01f3cde390a2","40":"c10c9f80209d0d6d0732","41":"c1ad038cdfde4398c8c5","43":"f3fd061f149bde5633ee","44":"f3176d82240fbdc0adf5","45":"ecb5b990497ddd73f55c","46":"7b87d977b34b9c4b761c","47":"a4ac3405786dc57c0223","48":"413d57f41d5d7ce8491f","49":"9bc57fea967bbced2891","50":"9d7ec41ffe8234e4efb5","51":"7c901bb9cdbc0e775f1a","54":"d8890cb690cfeddb64b7","55":"a7c9c0ead2d18a769d19","56":"0d5884d81029fea72814","57":"72ea49fb47f252d79d97","58":"5780d3b55f6e7ee54784","59":"495057ad580dc880f8bb","60":"34a09a6eb6b426b3e24a","61":"671f9049bdaf672921c1","62":"5b097d4c0bdce992d404","72":"d67d69ca168312e5ccec","73":"8b0c5431d58114250aab","74":"3463cffd94fb7027552b","75":"d62328eefe579971d748","76":"af52a6002765872c6309","122":"44e505fe1f5f11d59087","123":"c5e94754734b3b19c613","124":"c65479bcaa614ed585b3","125":"182ddd915434741d7af7","126":"17fd59867a9ac55f57e7","127":"cf8367932c447d7ad3e8","128":"a10828c24d56727338b6","129":"d324cb4072fb38f0bac8","130":"f0770b6918e0e04e2dd7","131":"6ac8e6887b36878a25e3","132":"03eff02aee7965ccf4d5","133":"9d697f16a4a927a53a86","134":"d8b101ba49da1136abc9","135":"2fa8149c65d374a2c126","136":"742ab06f82fc101a1394","137":"f15321bfdd756125823c","138":"147bc0fca37e88440b12","139":"37160579d3b081c74abd","140":"21f9cfbdb3dcf1c8eb35","141":"7cfa9a2102b8a1b67db9","142":"2f4f84df709affa622c2","143":"6cf686df160b82420702","144":"65c61b968cd892208779","145":"c7d5bc31840c34a52717","146":"eabecf165f2007da9df1","147":"26e3c4edeb515574bb76","148":"547151be4b81403f8bfa","149":"ba80461dfe2bf5ea75b5","150":"2c5742f8c77e23ac2fc9","151":"08ec5e84448a96b29c54"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		var threw = true;
 		try {
 			modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
 			threw = false;
 		} finally {
 			if(threw) delete installedModules[moduleId];
 		}

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"44":1,"45":1,"47":1,"49":1,"54":1,"55":1,"56":1,"58":1,"59":1,"60":1,"61":1,"62":1,"72":1,"73":1,"135":1,"136":1,"137":1,"139":1,"140":1,"141":1,"142":1,"143":1,"144":1,"145":1,"146":1,"147":1,"150":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "static/css/" + {"0":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"1249ca0e56183c3725b2","45":"9a7d7057e51b7fdb5ccb","46":"31d6cfe0d16ae931b73c","47":"a98420ed4ce9fe4278ff","48":"31d6cfe0d16ae931b73c","49":"a98420ed4ce9fe4278ff","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","54":"6fa308c32e64770d8b5d","55":"a98420ed4ce9fe4278ff","56":"5650f4f6f435f156cc9f","57":"31d6cfe0d16ae931b73c","58":"af3ad95c179c89db825d","59":"a98420ed4ce9fe4278ff","60":"c48cdba4d1aa30c4d508","61":"c48cdba4d1aa30c4d508","62":"af3ad95c179c89db825d","72":"af3ad95c179c89db825d","73":"a98420ed4ce9fe4278ff","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","122":"31d6cfe0d16ae931b73c","123":"31d6cfe0d16ae931b73c","124":"31d6cfe0d16ae931b73c","125":"31d6cfe0d16ae931b73c","126":"31d6cfe0d16ae931b73c","127":"31d6cfe0d16ae931b73c","128":"31d6cfe0d16ae931b73c","129":"31d6cfe0d16ae931b73c","130":"31d6cfe0d16ae931b73c","131":"31d6cfe0d16ae931b73c","132":"31d6cfe0d16ae931b73c","133":"31d6cfe0d16ae931b73c","134":"31d6cfe0d16ae931b73c","135":"6fa308c32e64770d8b5d","136":"af3ad95c179c89db825d","137":"6fa308c32e64770d8b5d","138":"31d6cfe0d16ae931b73c","139":"1249ca0e56183c3725b2","140":"5650f4f6f435f156cc9f","141":"9a7d7057e51b7fdb5ccb","142":"5650f4f6f435f156cc9f","143":"a98420ed4ce9fe4278ff","144":"a98420ed4ce9fe4278ff","145":"a98420ed4ce9fe4278ff","146":"c48cdba4d1aa30c4d508","147":"af3ad95c179c89db825d","148":"31d6cfe0d16ae931b73c","149":"31d6cfe0d16ae931b73c","150":"a98420ed4ce9fe4278ff","151":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
